<form [formGroup]="questionForm" novalidate>
    <ion-item class="circle" (click)="focusInput()">
        <ion-input #numberInput formControlName="current" class="value" type="text" [value]="questionForm.get('current').value"></ion-input>
    </ion-item>
</form>
